import clsx from 'clsx'
import { FC } from 'react'
import SingleArrowIcon from '../../components/icons/SingleArrowIcon'
import { useAppSelector } from '../../hooks/useStore'

type IProps = {
  id: string
}

const ArrowIcon: FC<IProps> = ({ id }) => {
  const { isToggle, selectedMenu } = useAppSelector((state) => state.dashboardUi.sidebar)
  return (
    <div
      className={clsx(
        'flex item-center',
        id === selectedMenu ? '-rotate-90 text-blue-400 duration-300' : 'duration-300',
        isToggle ? 'hidden' : 'block',
      )}
    >
      <SingleArrowIcon />
    </div>
  )
}

export default ArrowIcon
